import { CheckCircle2 } from 'lucide-react';

export default function SuccessModal({ 
  show, 
  formData, 
  onClose 
}) {
  if (!show) return null;

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center p-4 bg-black bg-opacity-50">
      <div className="overflow-hidden mx-4 w-full max-w-md bg-white rounded-2xl shadow-2xl">
        <div className="p-6 text-center">
          <div className="flex justify-center items-center mx-auto mb-6 w-20 h-20 bg-emerald-100 rounded-full">
            <CheckCircle2 size={40} className="text-emerald-600" />
          </div>
          <h3 className="mb-2 text-xl font-semibold text-gray-900">Payment Method Added!</h3>
          <p className="mb-6 text-gray-600">
            Your {formData.providerName} account has been successfully added as a payment method.
          </p>
          <button
            onClick={onClose}
            className="px-4 py-3 w-full font-medium text-white bg-emerald-600 rounded-lg transition-colors hover:bg-emerald-700"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
